module.exports = __webpack_public_path__ + "img/1491434691.fda072c1.jpg";